/**
 * Pure fetch helper for GET /spaces/{spaceId}/memory.
 * Extracted from `useGetSpaceMemory` so callers (e.g. the sweet-state store)
 * can invoke it without depending on React or the hook lifecycle.
 */
import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';

/** API response shape for a single memory item. */
export type SpaceMemoryItem = {
	id: string;
	spaceId: string;
	content: string;
	createdAt: string;
};

/** API response shape for GET /spaces/{spaceId}/memory. */
export type GetSpaceMemoryResponse = {
	items: SpaceMemoryItem[];
};

export type GetSpaceMemoryFetchParams = {
	spaceId: string;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const getSpaceMemoryFetchAction = ({
	spaceId,
	cloudId,
	product,
	experienceId,
}: GetSpaceMemoryFetchParams): Promise<GetSpaceMemoryResponse> =>
	performHttpFetch<GetSpaceMemoryResponse>({
		path: `${SPACES_API_PATH}/${spaceId}/memory`,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		},
	});
